// simulator/pages/autoescuela/cursos/cursosUtils.js — copia de apps/driving-school/src/utils/cursos.js
// para el SIMULADOR de ventas (Cursos de autoescuela). Mismas reglas y textos; lo único añadido es
// un `t` opcional en las funciones que devuelven texto, para traducirlo con el namespace "autoescuela".
// Si cambias la real, cambia esta.

export const TIPOS_CURSO = {
  recuperacion_puntos: "Recuperación de puntos",
  cap_inicial: "CAP inicial",
  cap_continuo: "CAP formación continua",
  adr: "ADR (mercancías peligrosas)",
  carretilla: "Carretilla elevadora",
  intensivo_teorica: "Intensivo de teórica",
  sensibilizacion: "Sensibilización vial",
  otro: "Otro",
};

const sinT = (_k, d, o) => (o ? String(d).replace(/{{(\w+)}}/g, (_, n) => o[n]) : d);

export const tipoCursoLabel = (tipo, t = sinT) => (TIPOS_CURSO[tipo] ? t(`cursos.tipos.${tipo}`, TIPOS_CURSO[tipo]) : "");

export const esCap = (tipo) => tipo === "cap_inicial" || tipo === "cap_continuo";

export const ESTADO_EDICION = {
  abierta: { label: "Abierta", cls: "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200" },
  llena: { label: "Llena", cls: "bg-amber-50 text-amber-700 ring-1 ring-amber-200" },
  cerrada: { label: "Cerrada", cls: "bg-gray-100 text-gray-600 ring-1 ring-gray-200" },
  finalizada: { label: "Finalizada", cls: "bg-slate-100 text-slate-600 ring-1 ring-slate-200" },
};

export function estadoEdicion(estadoVisible, t = sinT) {
  const key = ESTADO_EDICION[estadoVisible] ? estadoVisible : "cerrada";
  const st = ESTADO_EDICION[key];
  return { ...st, label: t(`cursos.estado.${key}`, st.label) };
}

export const PAGO = {
  pendiente: { label: "Pago pendiente", cls: "bg-amber-50 text-amber-700" },
  pagado: { label: "Pagado", cls: "bg-emerald-50 text-emerald-700" },
  reembolsado: { label: "Reembolsado", cls: "bg-gray-100 text-gray-600" },
  no_aplica: null,
};

export function pagoChip(pago, t = sinT) {
  const p = PAGO[pago];
  return p ? { ...p, label: t(`cursos.pago.${pago}`, p.label) } : null;
}

export function fmtFecha(ymd) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(ymd || ""))) return "";
  const [y, m, d] = ymd.split("-");
  return `${d}/${m}/${y}`;
}

const DIAS = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
export function fmtFechaCorta(ymd) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(ymd || ""))) return "";
  const [y, m, d] = ymd.split("-").map(Number);
  const dow = new Date(Date.UTC(y, m - 1, d)).getUTCDay();
  return `${DIAS[dow]} ${String(d).padStart(2, "0")}/${String(m).padStart(2, "0")}`;
}

export function fmtEuros(cents) {
  return `${(Number(cents || 0) / 100).toFixed(2).replace(".", ",")} €`;
}

/** "213,26" | "213.26" | 213.26 → 21326 ; vacío → 0 ; inválido → null */
export function eurosACentimos(v) {
  if (v === "" || v == null) return 0;
  const n = Number(String(v).replace(",", "."));
  if (!Number.isFinite(n) || n < 0) return null;
  return Math.round(n * 100);
}

export function centimosAEuros(c) {
  if (c == null) return "";
  return (Number(c) / 100).toFixed(2).replace(".", ",");
}

const min = (h) => { const [a, b] = String(h).split(":").map(Number); return a * 60 + b; };

export function horasSesion(s) {
  if (!/^\d{2}:\d{2}$/.test(s?.inicio || "") || !/^\d{2}:\d{2}$/.test(s?.fin || "")) return 0;
  const d = min(s.fin) - min(s.inicio);
  return d > 0 ? Math.round((d / 60) * 100) / 100 : 0;
}

export function horasTotales(sesiones) {
  return Math.round((sesiones || []).reduce((a, s) => a + horasSesion(s), 0) * 100) / 100;
}

/** Errores del editor de sesiones (mismo criterio que el backend). [] si todo bien. */
export function erroresSesiones(sesiones, t = sinT) {
  const out = [];
  if (!sesiones || sesiones.length === 0) out.push(t("cursos.errores.sesiones_obligatorias", "Añade al menos una sesión."));
  (sesiones || []).forEach((s, i) => {
    const n = i + 1;
    if (!s.fecha) out.push(t("cursos.sesionSinFecha", "Sesión {{n}}: falta la fecha.", { n }));
    else if (!s.inicio || !s.fin) out.push(t("cursos.sesionSinHora", "Sesión {{n}}: falta la hora.", { n }));
    else if (horasSesion(s) <= 0) out.push(t("cursos.sesionFinAntes", "Sesión {{n}}: la hora de fin va antes de la de inicio.", { n }));
  });
  return out;
}

/** Copia la última sesión al día siguiente (atajo para cursos de varios días seguidos). */
export function siguienteSesion(sesiones) {
  const last = (sesiones || [])[sesiones.length - 1];
  if (!last || !last.fecha) return { fecha: "", inicio: last?.inicio || "09:00", fin: last?.fin || "14:00" };
  const [y, m, d] = last.fecha.split("-").map(Number);
  const next = new Date(Date.UTC(y, m - 1, d + 1)).toISOString().slice(0, 10);
  return { fecha: next, inicio: last.inicio, fin: last.fin };
}

export function primeraFecha(edicion) {
  return (edicion?.sesiones || [])[0]?.fecha || "";
}

export function rangoFechas(edicion) {
  const s = edicion?.sesiones || [];
  if (!s.length) return "";
  const a = fmtFecha(s[0].fecha);
  const b = fmtFecha(s[s.length - 1].fecha);
  return a === b ? a : `${a} – ${b}`;
}

/** Asistió a todas las sesiones. */
export function asistenciaCompleta(insc, edicion) {
  const ses = edicion?.sesiones || [];
  if (!ses.length) return false;
  return ses.every((s) => insc?.asistencia?.[s.sesion_id] === true);
}

export function nombreCompleto(insc) {
  return `${insc?.nombre || ""} ${insc?.apellidos || ""}`.trim() || "Sin nombre";
}

/** wa.me con el texto prellenado y el código (igual que el backend). */
export function enlaceInscripcion(waNumber, nombreCurso, codigo) {
  const digits = String(waNumber || "").replace(/[^\d]/g, "");
  if (!digits || !codigo) return "";
  const texto = `Quiero apuntarme al curso ${String(nombreCurso || "").trim()} (código ${codigo})`;
  return `https://wa.me/${digits}?text=${encodeURIComponent(texto)}`;
}

/** Ediciones agrupadas por curso, próximas primero y finalizadas al final. */
export function edicionesPorCurso(cursos, ediciones) {
  const map = new Map((cursos || []).map((c) => [c.curso_id, { curso: c, ediciones: [] }]));
  for (const e of ediciones || []) {
    if (!map.has(e.curso_id)) map.set(e.curso_id, { curso: { curso_id: e.curso_id, nombre: e.curso_nombre, tipo: e.curso_tipo }, ediciones: [] });
    map.get(e.curso_id).ediciones.push(e);
  }
  const rank = (e) => (e.estado === "finalizada" ? 1 : 0);
  for (const g of map.values()) {
    g.ediciones.sort((a, b) => rank(a) - rank(b) || primeraFecha(a).localeCompare(primeraFecha(b)));
  }
  return [...map.values()];
}

const ERRORES = {
  tipo_invalido: "Elige el tipo de curso.",
  nombre_obligatorio: "El nombre es obligatorio.",
  precio_invalido: "El precio no es válido.",
  horas_invalidas: "Las horas no son válidas.",
  sesiones_obligatorias: "Añade al menos una sesión.",
  sesion_invalida: "Revisa las fechas y horas de las sesiones.",
  sesion_fin_antes_de_inicio: "En alguna sesión la hora de fin va antes de la de inicio.",
  plazas_max_invalidas: "Las plazas máximas tienen que estar entre 1 y 500.",
  plazas_min_invalidas: "Las plazas mínimas no pueden pasar de las máximas.",
  plazas_por_debajo_de_ocupadas: "Ya hay más personas apuntadas que esas plazas.",
  edicion_finalizada: "La edición está finalizada.",
  edicion_cerrada: "La edición está cerrada: ábrela para apuntar a alguien.",
  telefono_invalido: "El teléfono no es válido.",
  ya_inscrito: "Ese teléfono ya está apuntado a esta edición.",
  llena: "No quedan plazas libres.",
  no_en_espera: "Esa persona ya no está en la lista de espera.",
  ya_cancelada: "La inscripción ya estaba cancelada.",
  sin_plaza: "Solo se pasa lista a quien tiene plaza.",
};

/** El store del simulador lanza los errores con la misma forma que axios ({ response.data.error }). */
export function mensajeError(err, fallback = "No se ha podido guardar.", t = sinT) {
  const code = err?.response?.data?.error;
  return ERRORES[code] ? t(`cursos.errores.${code}`, ERRORES[code]) : fallback;
}
